/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSuperstackingSettingsRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'
import {GetSuperstackingSettingsResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'


export const getSuperstackingSettings = (request: GetSuperstackingSettingsRequest, options?: CashRequestOptions) => post<GetSuperstackingSettingsRequest, GetSuperstackingSettingsResponse>("/2.0/cash/get-superstacking-settings", request, {...options, rejectOnError: true })